"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFamiliesMobile = void 0;
exports.fontFamiliesMobile = {
    inter100: "Inter_100Thin",
    inter200: "Inter_200ExtraLight",
    inter300: "Inter_300Light",
    inter400: "Inter_400Regular",
    inter500: "Inter_500Medium",
    inter600: "Inter_600SemiBold",
    inter700: "Inter_700Bold",
    inter800: "Inter_800ExtraBold",
    inter900: "Inter_900Black",
    playfairDisplay500: "PlayfairDisplay_500Medium"
};
